module.exports = __webpack_public_path__ + "static/media/image-card-1.14e89296.png";